/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';

const RandomNumberAnimation = ({ finalNumber, intervalTime = 500 }: any) => {
    const [displayedNumber, setDisplayedNumber] = useState(0);

    useEffect(() => {
        const startTime = Date.now();

        const interval = setInterval(() => {
            const elapsedTime = Date.now() - startTime;

            if (elapsedTime < intervalTime) {
                const randomNum = Math.floor(Math.random() * 100);
                setDisplayedNumber(randomNum);
            } else {
                clearInterval(interval);
                setDisplayedNumber(finalNumber);
            }
        }, 50); // Cambia el número aleatorio cada 50ms

        return () => clearInterval(interval);
    }, [finalNumber]);
    return displayedNumber;
};

export default RandomNumberAnimation;
